/**
 * Stock Report API Service
 * @see Sprint 16 - Rapport de Stock
 * @see US-16.5 - UI Rapport Principal
 */

import { apiClient } from '@/api/client';
import type {
  StockReportData,
  StockReportKPIs,
  StockReportQueryParams,
} from '@bstock/shared';

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

/**
 * Get stock report for a period
 */
export async function getStockReport(
  params: StockReportQueryParams
): Promise<StockReportData> {
  const response = await apiClient.get<ApiResponse<StockReportData>>(
    '/reports/stock',
    { params }
  );
  return response.data.data;
}

/**
 * Get stock report KPIs
 */
export async function getStockReportKPIs(
  params: StockReportQueryParams
): Promise<StockReportKPIs> {
  const response = await apiClient.get<ApiResponse<StockReportKPIs>>(
    '/reports/stock/kpis',
    { params }
  );
  return response.data.data;
}
